var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.titleTxt!=='')?_c('div',{staticClass:"article-title"},[_c('div',{staticClass:"article-title-txt"},[_vm._v(_vm._s(_vm.titleTxt))]),_c('div',{staticClass:"article-title-task"},[_vm._v(" "+_vm._s(_vm.titleTask)+" "),_c('i',{staticClass:"fa fa-chevron-right",attrs:{"aria-hidden":"true"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }